import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const WhatsNew = lazy(() => import("@/pages/WhatsNew"));

export const Route = createFileRoute("/_public/whats-new")({
  head: () => pageHead({ path: "/whats-new", title: "What's New | Amorette", description: "The latest articles, editorial highlights, and platform updates from Amorette." }),
  component: WhatsNew,
});
